import React, {Component} from "react";
import {DatePicker, Form, Input, Switch} from 'antd';
import NHFormItem from '../../../common/NHFormItem/index';
import PropTypes from 'prop-types';
import moment from 'moment';

/**
 * @author weishihuai
 * @date 2018/6/28
 * @time 16:07
 * @Description: 步骤一：表单基本信息配置
 */
class FirstStep extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            startValue: null,
            endValue: null,
        }
    }

    disabledStartDate = (startValue) => {
        const endValue = this.state.endValue;
        if (!startValue || !endValue) {
            return false;
        }
        return startValue.valueOf() > endValue.valueOf();
    };

    disabledEndDate = (endValue) => {
        const startValue = this.state.startValue;
        if (!endValue || !startValue) {
            return false;
        }
        return endValue.valueOf() <= startValue.valueOf();
    };

    onChange = (field, value) => {
        this.setState({
            [field]: value,
        });
    };

    onStartChange = (value) => {
        this.onChange('startValue', value);
    };

    onEndChange = (value) => {
        this.onChange('endValue', value);
    };

    render() {
        const {form, data} = this.props;
        const {startValue, endValue} = this.state;

        return (
            <div>
                <Form layout="horizontal">
                    <NHFormItem id={'bdmc'} label={'表单名称'} hasFeedback={true} form={form} required={true}
                                pattern={{max: 300, message: "表单名称长度不能超过300字符！"}}
                                initialValue={data.bdmc}>
                        <Input placeholder="请输入表单名称"/>
                    </NHFormItem>
                    <NHFormItem id={'bdcjts'} label={'表单采集提示'} hasFeedback={true} form={form}
                                pattern={{max: 4000, message: "表单采集提示长度不能超过4000字符！"}}
                                initialValue={data.bdcjts}>
                        <Input placeholder="请输入表单采集提示"/>
                    </NHFormItem>
                    <NHFormItem id={'kssj'} label={'采集开始时间'} form={form} required={true}
                                initialValue={data.kssj ? moment(data.kssj) : startValue}>
                        <DatePicker
                            disabledDate={this.disabledStartDate}
                            showTime
                            format="YYYY-MM-DD HH:mm:ss"
                            placeholder="采集开始时间"
                            onChange={this.onStartChange}
                        />
                    </NHFormItem>
                    <NHFormItem id={'jssj'} label={'采集结束时间'} form={form} required={true}
                                initialValue={data.jssj ? moment(data.jssj) : endValue}>
                        <DatePicker
                            disabledDate={this.disabledEndDate}
                            showTime
                            format="YYYY-MM-DD HH:mm:ss"
                            placeholder="采集结束时间"
                            onChange={this.onEndChange}
                        />
                    </NHFormItem>
                    <NHFormItem id={'wkscjts'} label={'未开始采集提示'} hasFeedback={true} form={form}
                                pattern={{max: 4000, message: "未开始采集提示长度不能超过4000字符！"}}
                                initialValue={data.wkscjts}>
                        <Input placeholder="请输入未开始采集提示"/>
                    </NHFormItem>
                    <NHFormItem id={'zt'} label={'状态'} form={form} valuePropName={'checked'}
                                initialValue={data.zt ? (data.zt === '1') : false}>
                        <Switch checkedChildren="启用" unCheckedChildren="停用"/>
                    </NHFormItem>
                </Form>
            </div>
        )
    }
}

FirstStep.defaultProps = {
    data: {}
};

FirstStep.propTypes = {
    data: PropTypes.object,      //初始表单数据
    update: PropTypes.bool,      //是否是更新操作
};

const firstStep = Form.create({
    onValuesChange(props, values) {
        props.onChange(values);
    }
})(FirstStep);
export default firstStep;


// WEBPACK FOOTER //
// ./components/xxcj/bdgl/edit-form/step-first.js